import React from 'react';
import { RefreshCw, Sparkles } from 'lucide-react';

interface UpdateToastProps {
  show: boolean;
  onRefresh: () => void;
}

export const UpdateToast: React.FC<UpdateToastProps> = ({ show, onRefresh }) => {
  if (!show) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] w-[calc(100%-2rem)] max-w-lg"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 rounded-2xl border border-secondary-500/50 bg-stone-900 px-4 py-3 shadow-xl shadow-black/40">
        <div className="shrink-0 rounded-xl bg-secondary-500/20 p-2">
          <Sparkles className="h-6 w-6 animate-pulse text-secondary-300" />
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-secondary-300">
            Actualización lista
          </p>
          <h4 className="text-sm font-medium leading-snug text-white">
            Nueva versión disponible
          </h4>
          <p className="mt-0.5 text-xs leading-snug text-white/70">
            Recarga para usar las últimas mejoras.
          </p>
        </div>

        <button
          type="button"
          onClick={onRefresh}
          className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-secondary-500 px-4 py-2 text-xs font-bold text-white transition-colors hover:bg-secondary-400 active:scale-[0.98]"
        >
          <RefreshCw className="h-3.5 w-3.5" />
          Actualizar
        </button>
      </div>
    </div>
  );
};
